export type NativeLabelKey = "with_team" | "waiting_on_you" | "resolved";
export type NativeEventKind =
  | "opened"
  | "with_team"
  | "waiting_on_you"
  | "resolved";
export type NativeRequest = {
  id: string;
  title: string;
  label_key: NativeLabelKey;
  opened_at: string;
  resolved_at: string | null;
  closed_at: string | null;
  latest_event_at: string;
};
export type NativeRequestEvent = {
  id: string;
  request_id: string;
  kind: NativeEventKind;
  at: string;
};
export type NativeCursor = { at: string; id: string };
export type NativeRequests = {
  requests: NativeRequest[];
  events: NativeRequestEvent[];
  requests_complete: boolean;
  has_more_events: boolean;
  next_request_cursor: NativeCursor | null;
  next_event_cursor: NativeCursor | null;
};
export const nativeSupportEnabled = () =>
  import.meta.env.VITE_NATIVE_PATIENT_REQUESTS_ENABLED === "true";
